import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const checkboxExamplesPageRoute: RouteConfig<'with-page'> = {
    name: 'Checkbox Examples',
    path: '/checkbox-examples',
    page: lazy(() => import('.')),
    icon: 'mdi mdi-checkbox-marked-outline',
    roles: ['developer'],
}
